import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TimesheetService } from '../services/timesheet.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  formControl: any;
  loading = false;
  error = '';
  sent = false;
  submittedEmail = '';

  constructor(
    private timesheetService: TimesheetService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ForgotPasswordComponent>
  ) {
    this.formControl = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
  }

  submitForm() {
    if (!this.formControl.valid || this.loading) { return; }
    this.loading = true;
    this.error = '';
    const email = this.formControl.value.email;
    this.timesheetService.forgotPassword({ email }).subscribe(res => {
      this.loading = false;
      this.sent = true;
      this.submittedEmail = email;
    }, error => {
      this.error = error;
      this.loading = false;
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onDone() {
    this.dialogRef.close({ emailSent: true, email: this.submittedEmail });
  }
}
